module.exports = __webpack_public_path__ + "static/jaskova-8a5af3a281b3777da0ed1460d01a2d33.jpg";